import React from 'react';

import { ia, iaRa, optionify } from 'lib/helpers/utility';
import { useOrganizationLocations } from 'lib/hooks/queries/organization/useOrganizationLocations';

import Select from 'components/shared/Select/Select';

const NewPatientMultiMid = ({ formik }) => {
  const { data: locationData, isFetching } = useOrganizationLocations({
    select: (response) => optionify(iaRa(response?.locations), 'name', 'id')
  });

  if (isFetching || !ia(locationData)) {
    return;
  }

  return (
    <div className="mt-9 grid grid-cols-1">
      <div className="flex gap-2 mb-4 items-center">
        <h3 className="text-lg font-600">Add to Multiple Locations</h3>
      </div>
      <div>
        <label
          className="m-0 block pb-[6px] text-sm font-500 text-neutral-800"
          htmlFor="practice-location">
          Practice Location
        </label>
        <Select
          placeholder="Select Practice Location"
          value={formik.values.practice_locations}
          onChange={(value) => formik.setFieldValue('practice_locations', value)}
          isMulti
          options={locationData}
          inputId="practice-location"
        />
      </div>
    </div>
  );
};

export default NewPatientMultiMid;
